"use server";

import { and, eq, gt, isNull } from "drizzle-orm";
import { redirect } from "next/navigation";
import { db, schema } from "@/db";
import {
  createSession,
  destroySession,
  hashPassword,
  verifyPassword,
} from "@/lib/auth";

export type FormState = { error?: string };

export async function login(
  _prev: FormState,
  formData: FormData,
): Promise<FormState> {
  const email = String(formData.get("email") ?? "")
    .trim()
    .toLowerCase();
  const password = String(formData.get("password") ?? "");
  if (!email || !password) return { error: "Введите email и пароль" };

  const [user] = await db
    .select()
    .from(schema.users)
    .where(and(eq(schema.users.email, email), eq(schema.users.isActive, true)))
    .limit(1);

  if (!user?.passwordHash || !(await verifyPassword(user.passwordHash, password))) {
    return { error: "Неверный email или пароль" };
  }

  await createSession(user.id);
  redirect("/");
}

export async function logout() {
  await destroySession();
  redirect("/login");
}

export async function activateInvite(
  token: string,
  _prev: FormState,
  formData: FormData,
): Promise<FormState> {
  const password = String(formData.get("password") ?? "");
  const password2 = String(formData.get("password2") ?? "");
  if (password.length < 8) return { error: "Пароль минимум 8 символов" };
  if (password !== password2) return { error: "Пароли не совпадают" };

  const [user] = await db
    .select()
    .from(schema.users)
    .where(
      and(
        eq(schema.users.inviteToken, token),
        gt(schema.users.inviteExpiresAt, new Date()),
        isNull(schema.users.passwordHash),
        eq(schema.users.isActive, true),
      ),
    )
    .limit(1);

  if (!user) return { error: "Ссылка недействительна или уже использована" };

  await db
    .update(schema.users)
    .set({
      passwordHash: await hashPassword(password),
      inviteToken: null,
      inviteExpiresAt: null,
    })
    .where(eq(schema.users.id, user.id));

  await createSession(user.id);
  redirect("/");
}
